<template>
  <SpinnerComponent :start="isLoading" />

  <div class="p--welcome">

    <div class="content-slide">
      <swiper v-if="isAds" :slides-per-view="1" :space-between="50" :autoplay="{delay: 3500, disableOnInteraction: false}" :modules="modules" class="box-ads-swiper">
        <swiper-slide v-for="a in ads" :key="a" class="item-ads-swiper">
          <img alt="default" :src="a['Image']">
        </swiper-slide>
      </swiper>
    </div>


    <div class="content-items">

      <div class="item">
        <a href="#" class="card-populer">
          <div class="card-populer-content" :style="{ backgroundImage: `url(${img01})` }" style="transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px);">
            <div class="card-populer-img">
              <img :src="img01">
            </div>
            <div class="card-populer-text">
              <span>{{ $t('_Welcome._Domestic_Money_Transfers') }}</span>
              <h1>{{ $t('_Welcome._Instant_Domestic_Money_Transfers') }}</h1>
            </div>
            <div class="mask"></div>
          </div>
        </a>
      </div>

      <div class="item">
        <a href="#" class="card-populer">
          <div class="card-populer-content" :style="{ backgroundImage: `url(${img02})` }" style="transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px);">
            <div class="card-populer-img">
              <img :src="img02">
            </div>
            <div class="card-populer-text">
              <span>{{ $t('_Welcome._International_Money_Transfers') }}</span>
              <h1>{{ $t('_Welcome._Uncomplicated_International_Transfers') }}</h1>
            </div>
            <div class="mask"></div>
          </div>
        </a>
      </div>

      <div class="item">
        <a href="#" class="card-populer">
          <div class="card-populer-content" :style="{ backgroundImage: `url(${img03})` }" style="transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px);">
            <div class="card-populer-img">
              <img :src="img03">
            </div>
            <div class="card-populer-text">
              <span>{{ $t('_Welcome._Deposit_Withdrawal') }}</span>
              <h1>{{ $t('_Welcome._Secure_Deposit_Withdrawal') }}</h1>
            </div>
            <div class="mask"></div>
          </div>
        </a>
      </div>

      <div class="item">
        <a href="#" class="card-populer">
          <div class="card-populer-content" :style="{ backgroundImage: `url(${img04})` }" style="transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px);">
            <div class="card-populer-img">
              <img :src="img04">
            </div>
            <div class="card-populer-text">
              <span>{{ $t('_Welcome._Currency_Exchange') }}</span>
              <h1>{{ $t('_Welcome._Real_time_Instant_Exchange') }}</h1>
            </div>
            <div class="mask"></div>
          </div>
        </a>
      </div>

    </div>

    <div class="box-img-bros">
      <v-img class="logo-app" src="../assets/img/bros.png"></v-img>
    </div>


    <div class="footer-app">
      <div class="box-app">
        <v-img class="logo-app" src="../assets/logo.png"></v-img>
        <h3 style="margin: 0;">{{ $t('_public._name_app') }}</h3>
      </div>
      <p>{{ $t('_Welcome._Welcome_text') }}</p>
    </div>
  </div>
  
</template>
<script>
import SpinnerComponent from '@/components/SpinnerComponent.vue';
import router from "@/router";
import myUser, { _changLocalUser } from '../myUser'
import axios from 'axios';
// import router from "@/router";
// import myUser from '@/myUser';
// import { _changLocalUser } from '../myUser';
import { useDevice } from "@/components/useDevice.ts";

import { Swiper, SwiperSlide } from 'swiper/vue';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import imgBros from '../assets/img/bros.png';
import imgBg from '../assets/img/2518337100ff63a01fa44.jpg';

import img01 from '../assets/img/01.jpg';
import img02 from '../assets/img/02.jpg';
import img03 from '../assets/img/03.jpg';
import img04 from '../assets/img/04.jpg';


import imgTransfers from '../assets/img/transfers.jpeg';
import imgTransfers2 from '../assets/img/transfers2.jpg';

import imgCurrencyExchange from '../assets/img/currencyExchange.jpg';
import imgDepositWithdrawal from '../assets/img/depositWithdrawal.jpg';
import imgMoneyTransfers from '../assets/img/moneyTransfers.jpg';

export default {
  name: 'WelcomeView',
  components: { 
    SpinnerComponent,
    Swiper,
    SwiperSlide
  },
  data() {
    
    return {
      lang: this.$i18n.locale,
      isLoading: true,
      ads: [],
      isAds: false,
    }
  },
  methods: {
    async checkLogin() {
      if (myUser.isLogin == 'yes') {
        // console.log("app", myUser)
        if (myUser.check_security_code == 'yes') {
          router.push({ path: '/security-code' }) 
        } else {
          router.push({ path: '/home' }) 
          // console.log('home')
        }
      } else {
        this.getDataView();
      }
    },
    async getDataView(){
      this.getAllViewAds();
    },
    async getAllViewAds(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('ads.php?action=getAllViewAds', inputs).then((res) => {
        // console.log("getAllViewNews", res['data'])
        if (res['data']['msg'] == 'ok') {
          // console.log(res)
          // console.log(res['data']['items'])
          this.ads        = res['data']['ads'];
          this.isAds      = true;
          this.isLoading  = false;

        } else {
          this.isAds = false;
          // console.log(res['data']['msg']);
          this.isLoading = false;
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
  },
  mounted(){
    this.checkLogin();
    // _changLocalUser("isDisconnect", "network")
  },
  setup() {

    const { isMobile, isDesktop } = useDevice();
    return { 
      isMobile, 
      isDesktop,
      imgBros,
      imgBg,
      img01,
      img02,
      img03,
      img04,
      imgTransfers,
      imgTransfers2,
      imgCurrencyExchange,
      imgDepositWithdrawal,
      imgMoneyTransfers,
      modules: [Autoplay, Pagination, Navigation],
    };
  },
}
</script>
<style scoped>
.p--welcome {
  color: var(--color-text);
}
.para {
  padding: 26px;
}
.p-text {
  margin-bottom: 15px !important;
}
.start {
  text-align: start;
}
.content-slide {
  position: relative;
  width: 94%;
  margin: 0px 3%;
}
.box-ads-swiper {
  border-radius: 15px;
}
.box-ads-swiper .item-ads-swiper{
  border-radius: 15px;
}
.box-ads-swiper .item-ads-swiper img {
  max-height: 220px;
  width: 100%;
  border-radius: 15px;
}
.box-img-bros {
  position: relative;
  width: 70%;
  margin: 0px 15%;
}
.footer-app {
  position: relative;
  min-height: 100px;
  background: var(--box-background);
  border-top: 1px solid var(--border-color);
  padding: 26px;
  text-align: start;
}
.footer-app .box-app {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.footer-app .box-app .logo-app {
  height: 36px;
  max-width: 36px;
  margin-inline-end: 12px;
}
.footer-app .box-app h3 {
  font-size: 16px;
}
.footer-app p {
  margin-top: 16px;
  color: var(--color-text);
  font-size: 14px;
}


.content-items {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
  margin: 26px;
}
.content-items .item {
  width: 49%;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .content-items {
    margin: 16px;
  }
  .content-items .item {
    width: 100%;
  }
  .box-img-bros {
    width: 80%;
    margin: 0px 10%;
  }
}





.card-populer {
  border: 2px solid transparent;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  border-radius: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  position: relative;
  transition: all ease-in 0.1s;
}

.card-populer:hover {
  transition: all ease-in 0.1s;
  border: 2px solid var(--public);
}

.card-populer::before {
  position: absolute;
  content: "";
  width: 60px;
  height: 1400%;
  background-color: transparent;
  animation: animatepop 4s linear infinite;
}
.card-populer:hover::before {
  background-color: var(--public);
}

[data-theme="dark"] .card-populer:hover::before {
  background-color: #fff;
}

.card-populer::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background-color: #14192b;
  border-radius: 10px;
  overflow: hidden;
}

.card-populer:hover::after {
  width: calc(100% - 5px);
  height: calc(100% - 5px);
}

@keyframes animatepop {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.card-populer-content {
  position: relative;
  z-index: 10;
  color: aliceblue;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-position: top;
  background-position-y: 10%;
  background-size: cover;
  overflow: hidden;
  transition: all ease-out 0.1s;
}

.card-populer-content .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #14192b;
  opacity: 0.5;
  transition: all ease-out 0.3s;
  top: 0;
  left: 0;
  z-index: 1;
}

.card-populer:hover .card-populer-content .mask {
  opacity: 0.5;
  transition: all ease-out 0.3s;
}

.card-populer-text {
  display: flex;
  justify-content: center;
  align-items: start;
  text-align: start;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 2;
  transition: all ease-out 0.3s;
  flex-grow: 1;
  padding-right: 4px;
}

.card-populer:hover .card-populer-text {
  display: flex;
  justify-content: center;
  align-items: start;
  text-align: start;
  transition: all ease-out 0.3s;
  padding-right: 4px;
}

.card-populer-img {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  position: relative;
  z-index: 20;
  transition: all ease-out 0.3s;
}

.card-populer-img img {
  border-radius: 10px;
  height: calc(100% - 30px);
  aspect-ratio: 1/1;
  /* border: 1px solid #fff; */
  transition: all ease-out 0.3s;
}

.card-populer:hover .card-populer-img {
  /* padding: 0px 20px; */
  transition: all ease-out 0.3s;
}

.card-populer:hover .card-populer-img img {
  height: calc(100% - 30px);
  transition: all ease-out 0.3s;
}

.card-populer-content {
  display: flex;
  align-items: center;
}

.card-populer:hover .card-populer-content {
  width: calc(100% - 5px);
  height: calc(100% - 5px);
  transition: all ease-out 0.1s;
  position: relative;
}

.card-populer-content h1 {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  text-shadow: 1px 1px 4px #14192b;
}

.card-populer:hover .card-populer-content h1 {
  font-size: 16px;
}

.card-populer-content span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 1px 1px 4px #14192b;
  text-align: start;
}

@media (max-width: 756px) {
  .card-populer-content h1 {
    font-size: 12px;
    /* text-align: start; */
  }

  .card-populer:hover .card-populer-content h1 {
    font-size: 14px;
    /* text-align: start; */
  }

  .card-populer-content span {
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .card-populer-content h1 {
    font-size: 0.625rem;
    /* text-align: start; */
  }

  .card-populer:hover .card-populer-content h1 {
    font-size: 12px;
    text-align: start;
  }

  .card-populer-content span {
    font-size: 10px;
  }

  .card-populer {
    height: 80px;
  }

  .card-populer:hover .card-populer-img img {
    height: calc(100% - 30px);
  }

  .card-populer .card-populer-img {
    padding: 0px 10px;
  }

  .card-populer-img img {
    border-radius: 10px;
  }
}

.card-populer {
  transform-style: preserve-3d;
  perspective: 1000px;
  transition: transform 0.1s ease;
}

.card-populer:hover {
  transform: translateY(-5px);
}

.card-populer-content {
  transform-style: preserve-3d;
  transition: transform 0.1s ease;
}

.card-populer-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transform: skewX(-25deg);
  z-index: 3;
  pointer-events: none;
}

.card-populer:hover .card-populer-content::before {
  animation: shine 0.8s ease-in-out;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 150%;
  }
}

.card-populer-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at var(--mouse-x, 50%) var(--mouse-y, 0%),
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.card-populer:hover .card-populer-content::after {
  opacity: 1;
}

.card-populer-img::after {
  content: "";
  position: absolute;
  top: 10%;
  right: 10%;
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
  opacity: 0;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.8),
    0 0 20px rgba(255, 255, 255, 0.6),
    0 0 30px rgba(255, 255, 255, 0.4);
  z-index: 25;
}

.card-populer:hover .card-populer-img::after {
  animation: sparkle 1.5s ease-in-out infinite;
}

@keyframes sparkle {
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}

.card-populer:hover {
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(255, 215, 0, 0.2);
}

</style>

